import React, { useEffect, useState, useMemo } from 'react';
import useAsync from '../hooks/useAsync';
import { Link } from 'react-router-dom';
import LinkForm from './Button/Link.js'
import UserServices from '../services/OldProfileService.js';
import StateServices from '../services/StateServices';
import ViewUser from './View Model/ViewUser';
import Modal from 'react-modal';
import UserStatus from './TogelButton/UserStatus';
import UpdateProfile from './Update Model/UpdateProfile.js';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import Select from 'react-select';
Modal.setAppElement('#root');

function OldProfileUser() {
  const [currentPage, setCurrentPage] = useState(1);  // State to track the current page
  const [search, setSearch] = useState('');
  const [data1, setData1] = useState();
  const [data, setData] = useState();
  const [temp, setTemp] = useState(0);
  const usersPerPage = 50;  // You can adjust this value as needed
  const [filteredData, setFilteredData] = useState();
  const [statusFilter, setStatusFilter] = useState('');
  const [verifiedFilter, setVerifiedFilter] = useState('');
  const [districtFilter, setDistrictFilter] = useState('');
  const [policeStationFilter, setPoliceStationFilter] = useState('');
  const [districts, setDistricts] = useState([]);
  const [policeStations, setPoliceStations] = useState([]);
  // const { data, error, isLoading, run } = useAsync(() => UserServices.getAllUser(currentPage, usersPerPage));  // Fetch data based on current page and limit

  // Reset to page 1 when filters change (except currentPage itself)
  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  }, [search, statusFilter, verifiedFilter, districtFilter, policeStationFilter]);

  useEffect(() => {
    UserServices.getAllUser(currentPage, search, statusFilter, verifiedFilter, districtFilter, policeStationFilter).then((res) => {
      setData(res)
    }).catch((error) => {
      console.log(error)
    })
  }, [currentPage, search, statusFilter, verifiedFilter, districtFilter, policeStationFilter, temp])

  // Fetch districts on component mount
  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const response = await StateServices.getAllDistrict();
        const districtsData = response.data || [];
        // Remove duplicates based on _id
        const uniqueDistricts = districtsData.filter((district, index, self) =>
          index === self.findIndex((d) => d._id === district._id)
        );
        setDistricts(uniqueDistricts);
      } catch (error) {
        console.error('Failed to fetch districts', error);
      }
    };
    fetchDistricts();
  }, []);

  // Fetch police stations on component mount
  useEffect(() => {
    const fetchPoliceStations = async () => {
      try {
        const response = await StateServices.getAllThana();
        const stationsData = response.data || [];
        // Remove duplicates based on _id
        const uniqueStations = stationsData.filter((station, index, self) =>
          index === self.findIndex((s) => s._id === station._id)
        );
        setPoliceStations(uniqueStations);
      } catch (error) {
        console.error('Failed to fetch police stations', error);
      }
    };
    fetchPoliceStations();
  }, []);
  // useEffect(() => {
  //   const fetchData = () => {
  //     UserServices.getAllUser(currentPage)
  //       .then(res => setData(res))
  //       .catch(err => console.error(err));
  //   };
  //   fetchData();
  // }, [currentPage]);

  // useEffect(() => {
  //   if (search) {
  //     UserServices.getAllUserSearch(search)
  //       .then(res => setFilteredData(res))
  //       .catch(err => console.error(err));
  //   } else {
  //     setFilteredData(data);
  //   }
  // }, [search, data]);
  // // console.log(">>>", data)
  const count = data?.totalProfiles;  // Total profiles count


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const [selectedLink, setSelectedLink] = useState(null);
  const handleEditDetails = (thana) => {
    setSelectedEdit(thana);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };
  // const handleLinkDetails = (user) => {
  //   setSelectedLink(user);
  //   setIsLinkModalOpen(true);
  //   toggleActionMenu(null);
  // };
  const handleLinkDetails = (user) => {
    const userId = user?._id;
    const { presentAddress, permanentAddress } = user;

    const isMatching = ["mohalla", "state", "district", "policeStation", "pinCode"].every(
      (field) => presentAddress?.[field] === permanentAddress?.[field]
    );

    const encodedUserId = btoa(userId);
    const generatedLink = isMatching
      ? `https://pehchan.accredipath.com/match-form/${encodedUserId}`
      : `https://pehchan.accredipath.com/form/${encodedUserId}`;

    // Open the generated link in a new tab
    window.open(generatedLink, '_blank');
  };

  const closeLinkModal = () => {
    setIsLinkModalOpen(false);
    setSelectedLink(null);
  };
  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);  // Update current page state
  };
  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    return `${day}-${month}-${year}`;
  };


  // Format districts for react-select (unique by _id)
  const districtOptions = useMemo(() => {
    const uniqueDistricts = districts.filter((district, index, self) =>
      index === self.findIndex((d) => d._id === district._id)
    );
    return uniqueDistricts.map(district => ({
      value: district._id,
      label: district.name
    }));
  }, [districts]);

  // Format police stations for react-select (unique by _id, filtered by district)
  const policeStationOptions = useMemo(() => {
    let filteredStations = policeStations;
    
    // Filter by district if selected
    if (districtFilter) {
      filteredStations = policeStations.filter((station) => {
        const stationDistrictId = station.district?._id || station.district;
        return stationDistrictId === districtFilter || stationDistrictId?.toString() === districtFilter;
      });
    }
    
    // Remove duplicates based on _id
    const uniqueStations = filteredStations.filter((station, index, self) =>
      index === self.findIndex((s) => s._id === station._id)
    );
    
    return uniqueStations.map(station => ({
      value: station._id,
      label: station.name
    }));
  }, [policeStations, districtFilter]);

  // Get selected values for react-select
  const selectedDistrict = useMemo(() => 
    districtOptions.find(opt => opt.value === districtFilter) || null,
    [districtOptions, districtFilter]
  );

  const selectedPoliceStation = useMemo(() => 
    policeStationOptions.find(opt => opt.value === policeStationFilter) || null,
    [policeStationOptions, policeStationFilter]
  );

  // Get selected district and police station names for name-based matching
  const selectedDistrictName = useMemo(() => 
    selectedDistrict?.label || null,
    [selectedDistrict]
  );

  const selectedPoliceStationName = useMemo(() => 
    selectedPoliceStation?.label || null,
    [selectedPoliceStation]
  );

  // Data is now filtered on the backend, so we just use the data directly
  const filteredUsers = data?.data || [];

  const handleDownload = () => {
    // Construct API URL with optional search query
    const downloadUrl = `${process.env.REACT_APP_API_BASE_URL}/profile/download-excel${search ? `?search=${search}` : ''}`;


    // Trigger download by setting window location
    window.location.href = downloadUrl;
  };
  console.log(filteredUsers)
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Satyapan <span className="badge bg-warning">{count}</span></h2>
      </div>
      <div className="sub-title-box">
        <div className="sub-title-box-left">

        </div>

        <div className="sub-title-box-right">

          <button className="excel-btn" onClick={handleDownload}><img src="img/excel.svg" />Download</button>
        </div>
      </div>
      <div className="container-box px-0 user-manager">
        <div className="container-box-top-header px-4">
          <div className="container-box-top-header-left-2">
            <input
              type="search"
              name="search"
              placeholder="Search"
              value={search}
              onChange={handleSearchChange}
            />
            <button className="search-btn">Search</button>
            
            {/* Verified Filter Dropdown */}
            <select
              className="filter-dropdown"
              value={verifiedFilter}
              onChange={(e) => setVerifiedFilter(e.target.value)}
              style={{
                marginLeft: '10px',
                padding: '8px 12px',
                borderRadius: '4px',
                border: '1px solid #ddd',
                fontSize: '14px',
                cursor: 'pointer'
              }}
            >
              <option value="">All Verified</option>
              <option value="Valid">Valid</option>
              <option value="Invalid">Invalid</option>
            </select>
            
            {/* Status Filter Dropdown */}
            <select
              className="filter-dropdown"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{
                marginLeft: '10px',
                padding: '8px 12px',
                borderRadius: '4px',
                border: '1px solid #ddd',
                fontSize: '14px',
                cursor: 'pointer'
              }}
            >
              <option value="">All Status</option>
              <option value="Verify">Verify</option>
              <option value="UnVerify">UnVerify</option>
            </select>

            {/* District Filter Dropdown - Searchable */}
            <div style={{ marginLeft: '10px', minWidth: '200px', display: 'inline-block' }}>
              <Select
                value={selectedDistrict}
                onChange={(selectedOption) => {
                  setDistrictFilter(selectedOption ? selectedOption.value : '');
                  setPoliceStationFilter(''); // Reset police station when district changes
                }}
                options={districtOptions}
                placeholder="All Districts"
                isSearchable
                isClearable
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '38px',
                    fontSize: '14px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999
                  })
                }}
              />
            </div>

            {/* Police Station Filter Dropdown - Searchable */}
            <div style={{ marginLeft: '10px', minWidth: '200px', display: 'inline-block' }}>
              <Select
                value={selectedPoliceStation}
                onChange={(selectedOption) => {
                  setPoliceStationFilter(selectedOption ? selectedOption.value : '');
                }}
                options={policeStationOptions}
                placeholder="All Police Stations"
                isSearchable
                isClearable
                isDisabled={!districtFilter && false}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '38px',
                    fontSize: '14px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999
                  })
                }}
              />
            </div>
          </div>

        </div>
        <div className="container-box-inner">
          <table id="example" className="table table-striped" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>#</th>
                <th>App User</th>
                <th>Satyapan Name</th>
                <th>Aadhar No.</th>
                <th>Mobile No.</th>
                <th>Profession</th>
                <th>State</th>
                <th>District</th>
                <th>Police Station</th>
                <th>Verification ID</th>
                <th>Register Date</th>
                {/* <th>Status Label</th> */}
                <th>Status</th>
                <th>More Details</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers?.map((user, index) => (
                <tr key={user?._id}>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    {index + 1 + (currentPage - 1) * usersPerPage}
                  </td>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    <span >{user?.user?.name}</span>
                  </td>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    {user?.name}
                  </td>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    {user?.aadharNo}
                  </td>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    {user?.mobileNo}
                  </td>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    {user?.profession?.profession || 'N/A'}
                  </td>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    {user?.presentState?.name || 'N/A'}
                  </td>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    {user?.presentDistrict?.name || 'N/A'}
                  </td>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    {user?.presentPoliceStation?.name || 'N/A'}
                  </td>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    {user?.presentAddress?.policeStation?.code && user?.verificationId && user?.presentAddress?.district?.code
                      ? `${user.presentAddress.policeStation.code} ${user.verificationId} ${user.presentAddress.district.code}`
                      : user?.presentAddress?.policeStation?.code || user?.verificationId || user?.presentAddress?.district?.code
                        ? user.presentAddress.policeStation.code || user.verificationId || user?.presentAddress?.district?.code
                        : 'N/A'}
                  </td>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    {formatDate(user?.createdAt)}
                  </td>
                  {/* <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    <button
                      className="view-details-btn"
                      style={{
                        backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656',
                        color: 'white'
                      }}>
                      {user?.status}
                    </button>
                  </td> */}
                  <td className="status-toggle" style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}><UserStatus user={user} page={"user"} /></td>
                  <td style={{ backgroundColor: user?.status === 'Verify' ? '#2eb577' : '#ef4656', color: 'white' }}>
                    <div className="action_toggle_outer">
                      <button
                        className="action_toggle"
                        onClick={() => toggleActionMenu(index)}
                      >
                        <i className="fa fa-ellipsis-v" />
                      </button>
                      {activeIndex === index && (
                        <div className="action_toggle_content product-edit show d-block">
                          <ul className="list-unstyled">
                            <li>
                              <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                <i className="fa fa-close" />
                              </button>
                            </li>
                            {/* <li>
                              <button className="edit" onClick={() => handleEditDetails(user)}>Edit</button>
                            </li> */}
                            <li>
                              <button className="view-details-btn" onClick={() => handleViewDetails(user)}>View</button>
                            </li>
                            <li>
                              <button className="edit" style={{ backgroundColor: "#699836" }} onClick={() => handleLinkDetails(user)}>Print</button>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil(count / usersPerPage)}  // Total pages
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}  // Page change handler
            containerClassName={'pagination'}
            activeClassName={'active'}
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            initialPage={currentPage - 1}
            pageLinkClassName={'page-link'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            disabledClassName={'disabled'}
          />
        </div>
      </div>
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        contentLabel="Edit Category"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <UpdateProfile selectedData={selectedEdit} closeModal={closeEditModal} onSuccess={() => setTemp(temp + 1)} />
      </Modal>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewUser user={selectedUser} closeModal={closeModal} />
      </Modal>
      {/* <Modal
        isOpen={isLinkModalOpen}
        onRequestClose={closeLinkModal}
        contentLabel="Link Category"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <LinkForm user={selectedLink} closeModal={closeLinkModal} />
      </Modal> */}
    </div>
  )
}
export default OldProfileUser;


